module.exports = __webpack_public_path__ + "img/customer.6f823ac4.png";